import React, { useState, useRef, useEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import LabelR from '../Simple/LabelR';
import prettyBtyes from 'pretty-bytes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './DropZone.scss';

const DropZone = (props) => {
  const [dragging, setDragging] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [error, setError] = useState('');
  const {
    t,
    label,
    required,
    field: { name },
    form: { touched, errors, setFieldValue, setFieldTouched },
    allowedExt,
    maxSize,
    labelDropZone,
    maxSizeOlaClick,
  } = props;
  useEffect(() => {
    if (uploadedFile === null) {
      setFieldValue(name, '');
      setError('');
    }
  }, [uploadedFile]);
  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };
  const handleDragLeave = () => {
    setDragging(false);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const [file] = Array.from(e.dataTransfer.files);
    handleFile(file);
  };
  const handleFileInputChange = (e) => {
    const [file] = Array.from(e.target.files);
    handleFile(file);
  };
  const blobToFile = (blobFile, fileName) => {
    blobFile.lastModifiedDate = new Date();
    blobFile.name = fileName;
    return blobFile;
  };
  const handleFile = (file) => {
    if (!file) return;
    if (maxSize && file.size > maxSize) {
      setError(t('labelMaxSize', { size: prettyBtyes(maxSize) }));
      return;
    }
    const blob = new Blob([file], { type: 'text/csv' });
    const newFile = blobToFile(blob, file.name);
    const reader = new FileReader();
    let value = [];
    reader.onloadend = () => {
      value = [...value, { title: newFile.name, file: reader.result }];
      setFieldValue(name, value[0]);
    };
    reader.readAsDataURL(newFile);
    setUploadedFile(file);
  };
  const clearFile = (e) => {
    setUploadedFile(null);
    setFieldTouched(name);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    e.stopPropagation();
  };
  const openFileInput = () => {
    fileInputRef.current.click();
  };
  return (
    <div className="form-group">
      {label && (required ? <LabelR htmlFor={name}>{label}</LabelR> : <label htmlFor={name}>{label}</label>)}
      <div
        className={`dropzone ${dragging ? 'dragging' : ''}`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        onClick={openFileInput}
      >
        {uploadedFile ? (
          <div>
            <p>{uploadedFile.name}</p>
            <FontAwesomeIcon className="drop-zone__remove" icon={{ prefix: 'fal', iconName: 'trash-alt' }} onClick={clearFile} />
          </div>
        ) : (
          <p>
            {labelDropZone ? labelDropZone : t('labelDropZone')} {`(${allowedExt})`}
          </p>
        )}
        <input ref={fileInputRef} type="file" accept={allowedExt} style={{ display: 'none' }} onChange={handleFileInputChange} />
        <span className="drop-zone__rules">[{t(maxSizeOlaClick ? maxSizeOlaClick : 'labelMaxSize', { size: prettyBtyes(maxSize) })}]</span>
      </div>
      {error && <div className="invalid-feedback">{error}</div>}
      {touched[name] && errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
    </div>
  );
};

export default withNamespaces()(DropZone);
